@if (isMaterialIcon) {
<span [class]="color">
  <mat-icon [inline]="true">{{ asMaterialIcon }}</mat-icon>
</span>
} @if (!isMaterialIcon) {
<span [class]="asBootstrapIcon"></span>
}
